module.exports = "/_next/static/images/dd5904557cfd0d59aa21861ac68397ac-cuenta-card-xs.png.webp";